<span class="lookup-result-status status-word" [ngClass]="getStatusCss(license.lookupStatus)">{{ license.number }}</span>
&nbsp;
<span class="lookup-result-name" [innerHTML]="license.lookupName | highlight: highlight"></span>
<span class="lookup-result-info" [innerHTML]="license.lookupInfoWithoutNumber | highlight: highlight"></span>
